import { Response } from '@angular/http';

export default class HttpError {

  constructor(private response: Response, private urlUsed: string) { }

  get status(): number {
    return this.response.status;
  }

  get statusText(): string {
    return this.response.statusText;
  }

  get url(): string {
    return this.response.url || this.urlUsed;
  }

  get httpResponse(): Response {
    return this.response;
  }
}



// WEBPACK FOOTER //
// ./src/models/httpError.ts